import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import Utils from 'utils/Utils.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';

import {colors, spacings, fontSizes, fonts} from 'style';
import styleDef from './style';

var style= {
    ...styleDef,
    mcqButton: {
        backgroundColor:'rgba(0,0,0,0)',
        color: colors.themeBlue,
        border: '1px solid ' + colors.themeBlue,
        marginTop: spacings.small,
        marginBottom: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '320px',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
    },
    containerExpanded: {
        padding:'0px 10px 0px 10px',
    },
};

const MCQ = ({challenge, 
                       onComplete}) => (
    <Container style={{...style.container, ...style.containerExpanded}}>
    <div style={style.containerDiv}>
        <Segment style={style.segment}>
            <Grid style={style.grid} centered columns={1}>
                <Grid.Row verticalAlign='top' style={style.topRow}>
                    <Grid.Column verticalAlign='top'>
                        <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='middle'>
                        <Instructions challenge={challenge} />
                        {challenge.challengeAnswers.map((ca)=>(
                            <Button fluid key={ca.id} style={style.mcqButton} onClick={()=>onComplete(ca)}>{ca.label}</Button>
                        ))}
                    </Grid.Column>
                </Grid.Row>
              
                <Grid.Row verticalAlign='bottom'/>
            </Grid>
        </Segment>
    </div>
    </Container>
);

export default translate('challenges')(MCQ);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/MCQ.js